import { Search } from "lucide-react";
import { CHART_COLORS, PALETTE } from "../lib/theme";
import type { Section4 } from "../lib/types";

interface Props {
  data: Section4;
}

export function SectionGaps({ data }: Props) {
  const sorted = [...data.secteurs].sort(
    (a, b) => (b.score ?? 0) - (a.score ?? 0),
  );

  return (
    <div>
      <div className="mb-5 flex flex-col gap-4">
        {sorted.map((s, i) => {
          const c = CHART_COLORS[i % CHART_COLORS.length];
          return (
            <div
              key={`gap-${i}`}
              className="rounded-xl bg-white p-3.5"
              style={{ border: `1.5px solid ${c}44` }}
            >
              <div
                className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wide"
                style={{ color: c }}
              >
                <Search size={14} color={c} strokeWidth={2} />
                {s.nom}
              </div>
              {s.score !== undefined && (
                <div className="mb-3">
                  <div className="mb-1 flex justify-between text-xs text-slate-500">
                    <span>Score de sous-représentation</span>
                    <span className="font-bold" style={{ color: c }}>
                      {s.score}/100
                    </span>
                  </div>
                  <div className="h-2 overflow-hidden rounded-full bg-slate-200">
                    <div
                      className="h-full rounded-full"
                      style={{
                        width: `${Math.min(100, Math.max(0, s.score))}%`,
                        background: c,
                      }}
                    />
                  </div>
                </div>
              )}
              {s.exemples.map((ex, j) => (
                <div
                  key={`ex-${j}`}
                  className="mb-1.5 rounded-lg px-3 py-2.5"
                  style={{ background: `${c}10` }}
                >
                  <div className="text-sm font-semibold text-slate-700">
                    {ex.commerce}
                  </div>
                  <div className="mt-1 text-xs text-slate-500">
                    <span className="font-semibold text-slate-600">
                      Situé à{" "}
                    </span>
                    <strong>{ex.ville}</strong> ({ex.habitants} hab.)
                    {ex.distance ? ` — à ${ex.distance}` : ""}
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </div>

      <div className="mt-1">
        <div
          className="mb-3 text-[10px] font-bold uppercase tracking-widest"
          style={{ color: PALETTE[4] }}
        >
          Activités à implanter sur la zone
        </div>
        {sorted.map((s, i) => {
          const c = CHART_COLORS[i % CHART_COLORS.length];
          return (
            <div key={`bar-${i}`} className="mb-3.5">
              <div className="mb-1 flex items-baseline justify-between gap-2">
                <span className="text-sm font-semibold leading-tight text-slate-700">
                  {s.nom}
                </span>
                <span
                  className="shrink-0 text-sm font-bold"
                  style={{ color: c }}
                >
                  {s.score}/100
                </span>
              </div>
              <div className="h-2.5 overflow-hidden rounded-full bg-slate-200">
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${Math.min(100, Math.max(0, s.score ?? 0))}%`,
                    background: c,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
